import { APIError } from "@bvhi/backend-api";
import { usePermissions } from "../../../hooks/use-permissions.tsx";
import { MessagesInfoView } from "./info/messages.info.view.tsx";
import { MessagesListView } from "./list/message.list.view.tsx";

export const MessagesView = () => {
  const { hasPermissionTo } = usePermissions();

  if (!hasPermissionTo(["message:list", "message:info"])) {
    throw new APIError("Access denied.", {
      status: 401,
      code: "UNAUTHORIZED",
      message: "You are not allowed to access this page.",
      timestamp: new Date().toISOString(),
    });
  }

  // console.dir({
  //   a: hasPermissionTo(["message:list"]),
  //   b: hasPermissionTo(["message:info"]),
  // });
  if (hasPermissionTo(["message:list"])) return <MessagesListView />;

  return <MessagesInfoView />;
};
